import type { Column as TableColumn } from "@replo/design-system/components/table/Table";
import type { Product } from "schemas/generated/product";

import * as React from "react";

import { getPriceRange } from "@editor/components/dashboard/products/utils";

import { ProductTypeIcon } from "@/features/products/components/ProductTypeIcon";
import { PRODUCT_TYPE_OPTIONS } from "@/features/products/constants/product-type-options";
import { Package } from "lucide-react";

export function buildReploProductTableColumns(): TableColumn<Product>[] {
  return [
    {
      key: "product",
      header: "Name",
      width: "400px",
      renderCell: (product) => (
        <div className="flex items-center gap-3 min-w-0">
          {product.featuredMedia?.url ? (
            <img
              src={product.featuredMedia.url}
              alt={product.title}
              className="h-12 w-12 rounded object-cover flex-shrink-0"
            />
          ) : (
            <div className="bg-component text-muted flex h-12 w-12 items-center justify-center rounded flex-shrink-0">
              <Package className="h-6 w-6" />
            </div>
          )}
          <div className="flex flex-col min-w-0 flex-1">
            <div className="text-default cursor-pointer text-lg font-medium truncate">
              {product.title}
            </div>
            <div className="text-muted text-sm truncate">
              {product.slug ?? "N/A"}
            </div>
          </div>
        </div>
      ),
    },
    {
      key: "price",
      header: "Price",
      width: "150px",
      renderCell: (product) => (
        <div className="text-muted text-sm">
          {getPriceRange(product.variants)}
        </div>
      ),
    },
    {
      key: "type",
      header: "Type",
      width: "200px",
      renderCell: (product) => {
        const productTypeOption = PRODUCT_TYPE_OPTIONS.find(
          (option) => option.value === product.type,
        );

        if (!productTypeOption) {
          return (
            <div className="text-muted text-sm truncate">Uncategorized</div>
          );
        }

        return (
          <div className="flex items-center gap-2">
            <ProductTypeIcon
              icon={productTypeOption.icon}
              color={productTypeOption.color}
            />
            <span className="text-default text-sm truncate">
              {productTypeOption.label}
            </span>
          </div>
        );
      },
    },
  ];
}
